"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.regexp.replace");
var _slicedToArray2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/slicedToArray.js"));
require("core-js/modules/es6.regexp.match");
require("core-js/modules/es6.object.keys");
require("core-js/modules/es6.array.find-index");
require("core-js/modules/es6.array.find");
var _regeneratorRuntime2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _toConsumableArray2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es7.string.pad-start");
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.number.constructor");
var _vuex = require("vuex");
var _DragDialog = _interopRequireDefault(require("@/components/DragDialog"));
var _blExchangeAppointment = require("@/api/blExchangeAppointment/blExchangeAppointment");
var _utils = require("@/utils");
var _booking = require("@/api/bookSpace/booking");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'BatchReservationPhSaveDialog',
  components: {
    dragDialog: _DragDialog.default
  },
  props: {
    edoCreditId: {
      type: String,
      default: ''
    },
    vvLBlNo: {
      type: String,
      default: ''
    },
    del: {
      type: String,
      default: ''
    },
    formDialog: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    forespeakBlNo: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    forespeakStatus: {
      type: Number,
      default: 0
    },
    paymentStatus: {
      type: Number,
      default: 0
    },
    forespeakStatusList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    phEdoBankList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    paymentStatusList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    ecmNgbEdoOwnerType: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    hasDemurrage: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      demurrageFees: [{
        docEdoCreditFeeId: '',
        edoCreditId: '',
        paymentDate: '',
        paymentMethod: '',
        paymentCurrency: '',
        paymentAmount: '',
        invoiceNumber: '',
        paymentBank: '',
        paymentAccount: '',
        attachmentId: '',
        // 添加附件ID字段
        attachmentName: '',
        // 添加附件名称字段
        rowStatus: ''
      }],
      localFees: [{
        docEdoCreditFeeId: '',
        edoCreditId: '',
        paymentDate: '',
        paymentMethod: '',
        paymentCurrency: '',
        paymentAmount: '',
        invoiceNumber: '',
        paymentBank: '',
        paymentAccount: '',
        attachmentId: '',
        // 添加附件ID字段
        attachmentName: '',
        // 添加附件名称字段
        rowStatus: ''
      }],
      deletedLocalFees: [],
      // 新增：用于存储标记删除的本地费用
      deletedDemurrageFees: [],
      // 新增：用于存储标记删除的滞期费
      loading: null,
      checkOBL: false,
      checkSURRENDERED: false,
      defaultLocalInvoiceNumber: '',
      defaultDemInvoiceNumber: '',
      checkBG: false,
      checkFUC: false,
      fileList: [],
      fileTypeConfig: [{
        fileTypeCode: 'CONTAINER_GUARANTEE',
        fileTypeName: this.$t('blExchangeAppointment.containerGuarantee'),
        formField: 'containerGuarantee',
        showCondition: ['SURRENDERED', 'OBL', 'FUC', 'BG'],
        required: true
      }, {
        fileTypeCode: 'AUTHORIZATION_LETTER',
        fileTypeName: this.$t('blExchangeAppointment.authorizationLetter'),
        formField: 'authorizationLetter',
        showCondition: ['SURRENDERED', 'OBL', 'FUC', 'BG'],
        required: true
      }, {
        fileTypeCode: 'INSURANCE_CERTIFICATE',
        fileTypeName: this.$t('blExchangeAppointment.insuranceCertificate'),
        formField: 'insuranceCertificate',
        showCondition: ['SURRENDERED', 'OBL', 'FUC', 'BG'],
        required: true
      }, {
        fileTypeCode: 'ID_CARD_SCAN',
        fileTypeName: this.$t('blExchangeAppointment.idCardScan'),
        formField: 'idCardScan',
        showCondition: ['SURRENDERED', 'OBL', 'FUC', 'BG'],
        required: true
      }, {
        fileTypeCode: 'BILL_OF_LADING_COPY',
        fileTypeName: this.$t('blExchangeAppointment.billOfLadingCopy'),
        formField: 'billOfLadingCopy',
        showCondition: ['SURRENDERED'],
        required: true
      }, {
        fileTypeCode: 'DELIVERY_ORDER',
        fileTypeName: this.$t('blExchangeAppointment.deliveryOrder'),
        formField: 'deliveryOrder',
        showCondition: ['FUC'],
        required: true
      }, {
        fileTypeCode: 'OBL_FILE',
        fileTypeName: this.$t('blExchangeAppointment.obl'),
        formField: 'oblFileId',
        showCondition: ['OBL'],
        required: true
      }, {
        fileTypeCode: 'BANK_GUARANTY',
        fileTypeName: this.$t('blExchangeAppointment.bankGuaranty'),
        formField: 'bankGuarantyFileId',
        showCondition: ['BG'],
        required: true
      }, {
        fileTypeCode: 'PRE_TAX_RECEIPT',
        fileTypeName: this.$t('blExchangeAppointment.taxAttachment'),
        formField: 'taxAttachment',
        showCondition: ['ALL'],
        required: true,
        conditionalRequired: 'taxFlag == 1'
      },
      // { fileTypeCode: 'BANK_SLIP', fileTypeName: '银行水单', formField: 'bankSlip', showCondition: ['ALL'], required: true },
      {
        fileTypeCode: 'OBL_WITH_BANK_STAMP',
        fileTypeName: this.$t('blExchangeAppointment.oblWithBankStamp'),
        formField: 'oblWithBankStamp',
        showCondition: ['BG'],
        required: true
      }],
      paidTypeList: [{
        value: '0',
        labelEh: 'CASH DEPOSIT',
        labelCN: '现金存款'
      }, {
        value: '1',
        labelEh: 'BANK ONLINE TRANSFER',
        labelCN: '网银转账'
      }, {
        value: '2',
        labelEh: 'CHECK',
        labelCN: '支票'
      }],
      currencyList: [{
        value: 'USD',
        labelEh: 'USD',
        labelCN: 'USD'
      }, {
        value: 'PHP',
        labelEh: 'PHP',
        labelCN: 'PHP'
      }],
      documentTypeList: [{
        value: '0',
        labelEh: 'SURRENDERED',
        labelCN: '电放提单'
      }, {
        value: '1',
        labelEh: 'OBL',
        labelCN: '正本提单'
      }, {
        value: '2',
        labelEh: 'BANK GUARANTY',
        labelCN: '银行保函'
      }, {
        value: '3',
        labelEh: 'Forwarder & Ultimate consignee',
        labelCN: '货代单'
      }],
      invoiceHistory: JSON.parse(localStorage.getItem('invoiceHistory')) || [],
      form: {
        blNo: '',
        mail: '',
        forespeakBlNo: [],
        ownerType: '',
        identifier: '',
        consigneeName: '',
        consigneeAddress: '',
        paymentStatus: 0,
        forespeakStatus: 0,
        bankSlip: '',
        // 水单
        paymentType: '',
        paymentCurrency: '',
        paymentAmount: '',
        invoiceNumber: '',
        paymentDate: '',
        taxFlag: '0',
        documentType: '',
        oblFileId: '',
        bankGuarantyFileId: '',
        deliveryOrder: '',
        billOfLadingCopy: '',
        idCardScan: '',
        insuranceCertificate: '',
        authorizationLetter: '',
        containerGuarantee: '',
        demurrageReceipt: '',
        oblWithBankStamp: '',
        demurrageReceiptName: '',
        // 滞期费水单
        taxAttachment: '',
        // 预扣税税单文件名
        demurrageFees: [],
        // 滞期费费用
        localFees: [],
        // 本地费用
        approvalFiles: [],
        edoCreditFiles: {
          containerGuarantee: '',
          authorizationLetter: '',
          insuranceCertificate: '',
          idCardScan: '',
          billOfLadingCopy: '',
          deliveryOrder: '',
          oblFileId: '',
          bankGuarantyFileId: '',
          taxAttachment: '',
          demurrageReceipt: '',
          bankSlip: '',
          containerGuaranteeName: '',
          authorizationLetterName: '',
          insuranceCertificateName: '',
          idCardScanName: '',
          billOfLadingCopyName: '',
          deliveryOrderName: '',
          oblFileIdName: '',
          bankGuarantyFileIdName: '',
          taxAttachmentName: '',
          demurrageReceiptName: '',
          bankSlipName: ''
        }
      },
      rules: {
        ownerType: [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'change'
        }],
        consigneeName: [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'change'
        }],
        invoiceTitle: [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'change'
        }],
        identifier: [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'change'
        }],
        mail: [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'change'
        }],
        paymentDate: [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'change'
        }],
        paymentType: [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'change'
        }],
        paymentCurrency: [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'change'
        }],
        documentType: [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'change'
        }],
        invoiceNumber: [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'change'
        }],
        paymentAmount: [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'change'
        }, {
          validator: this.validateAmount,
          trigger: 'change'
        }]
      },
      // Add state for the shared bank slip
      currentBankSlipId: '',
      currentBankSlipName: '',
      fileEditStatus: {
        containerGuaranteeFileStatus: false,
        authorizationLetterFileStatus: false,
        insuranceCertificateFileStatus: false,
        idCardScanFileStatus: false,
        billOfLadingCopyFileStatus: false,
        deliveryOrderFileStatus: false,
        oblFileIdFileStatus: false,
        oblWithBankStampFileStatus: false,
        bankGuarantyFileIdFileStatus: false
      }
    };
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language'])), {}, {
    filteredDemurrageFees: function filteredDemurrageFees() {
      return this.demurrageFees ? this.demurrageFees.filter(function (fee) {
        return !fee._deleted;
      }) : [];
    },
    filteredLocalFees: function filteredLocalFees() {
      return this.localFees ? this.localFees.filter(function (fee) {
        return !fee._deleted;
      }) : [];
    }
  }),
  watch: {
    'form.documentType': {
      handler: function handler(value) {
        var _this = this;
        var checkMap = {
          0: {
            checkSURRENDERED: true,
            checkOBL: false,
            checkFUC: false,
            checkBG: false
          },
          1: {
            checkSURRENDERED: false,
            checkOBL: true,
            checkFUC: false,
            checkBG: false
          },
          2: {
            checkSURRENDERED: false,
            checkOBL: false,
            checkFUC: false,
            checkBG: true
          },
          3: {
            checkSURRENDERED: false,
            checkOBL: false,
            checkFUC: true,
            checkBG: false
          },
          default: {
            checkSURRENDERED: false,
            checkOBL: false,
            checkFUC: false,
            checkBG: false
          }
        };
        var checks = checkMap[value] || checkMap.default;
        this.checkSURRENDERED = checks.checkSURRENDERED;
        this.checkOBL = checks.checkOBL;
        this.checkFUC = checks.checkFUC;
        this.checkBG = checks.checkBG;

        // 使用nextTick确保DOM已更新后再初始化文件列表
        this.$nextTick(function () {
          setTimeout(function () {
            _this.initFileList();
          }, 100);
        });
      },
      immediate: true // 立即执行一次
    },
    // 监听状态列表变化，确保值匹配
    paymentStatusList: {
      handler: function handler() {
        this.initStatusValues();
      },
      immediate: true
    },
    forespeakStatusList: {
      handler: function handler() {
        this.initStatusValues();
      },
      immediate: true
    }
  },
  created: function created() {
    // 确保form对象初始化
    if (!this.form) {
      this.form = {
        blNo: '',
        mail: '',
        forespeakBlNo: [],
        ownerType: '',
        identifier: '',
        consigneeName: '',
        consigneeAddress: '',
        paymentStatus: this.paymentStatus || 0,
        forespeakStatus: this.forespeakStatus || 0,
        bankSlip: '',
        paymentType: '',
        paymentCurrency: '',
        paymentAmount: '',
        invoiceNumber: '',
        paymentDate: '',
        taxFlag: '0',
        documentType: '',
        oblFileId: '',
        bankGuarantyFileId: '',
        deliveryOrder: '',
        billOfLadingCopy: '',
        idCardScan: '',
        insuranceCertificate: '',
        authorizationLetter: '',
        containerGuarantee: '',
        demurrageReceipt: '',
        oblWithBankStamp: '',
        demurrageReceiptName: '',
        taxAttachment: '',
        demurrageFees: [],
        localFees: [],
        approvalFiles: [],
        edoCreditFiles: {}
      };
    }
    // 确保demurrageFees初始化
    if (!Array.isArray(this.demurrageFees) || this.demurrageFees.length === 0) {
      this.demurrageFees = [{
        docEdoCreditFeeId: '',
        edoCreditId: '',
        paymentDate: '',
        paymentMethod: '',
        paymentCurrency: '',
        paymentAmount: '',
        invoiceNumber: '',
        paymentBank: '',
        paymentAccount: '',
        attachmentId: '',
        // 添加附件ID字段
        attachmentName: '',
        // 添加附件名称字段
        rowStatus: ''
      }];
    }
    // 确保localFees初始化
    if (!Array.isArray(this.localFees) || this.localFees.length === 0) {
      this.localFees = [{
        docEdoCreditFeeId: '',
        edoCreditId: '',
        paymentDate: '',
        paymentMethod: '',
        paymentCurrency: '',
        paymentAmount: '',
        invoiceNumber: '',
        paymentBank: '',
        paymentAccount: '',
        attachmentId: '',
        // 添加附件ID字段
        attachmentName: '',
        // 添加附件名称字段
        rowStatus: ''
      }];
    }
  },
  methods: {
    // 添加文件上传前的大小验证方法
    beforeUpload: function beforeUpload(file) {
      // 文件大小限制为10MB (10 * 1024 * 1024 bytes)
      var isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error('上传文件大小不能超过10MB!');
      }
      return isLt10M;
    },
    // 初始化状态值
    initStatusValues: function initStatusValues() {
      if (this.form && this.paymentStatusList && this.paymentStatusList.length > 0) {
        // 确保是数字类型
        this.form.paymentStatus = Number(this.form.paymentStatus || this.paymentStatus || 0);
        console.log('初始化支付状态:', this.form.paymentStatus, this.paymentStatusList);
      }
      if (this.form && this.forespeakStatusList && this.forespeakStatusList.length > 0) {
        // 确保是数字类型
        this.form.forespeakStatus = Number(this.form.forespeakStatus || this.forespeakStatus || 0);
        console.log('初始化预约状态:', this.form.forespeakStatus, this.forespeakStatusList);
      }
    },
    // 增加一行
    addLocalFeesRow: function addLocalFeesRow() {
      this.localFees.push({
        docEdoCreditFeeId: '',
        paymentDate: '',
        paymentType: '',
        paymentCurrency: '',
        paymentAmount: '',
        invoiceNumber: this.defaultLocalInvoiceNumber || '',
        feeType: '0',
        attachmentId: this.currentBankSlipId,
        // 添加附件ID字段,水单是只有一份
        attachmentName: this.currentBankSlipName // 添加附件名称字段
      });
    },
    addDemurragesRow: function addDemurragesRow() {
      this.demurrageFees.push({
        docEdoCreditFeeId: '',
        paymentDate: '',
        paymentType: '',
        paymentCurrency: '',
        paymentAmount: '',
        invoiceNumber: this.defaultDemInvoiceNumber || '',
        feeType: '1',
        attachmentId: '',
        // 添加附件ID字段
        attachmentName: '' // 添加附件名称字段
      });
    },
    // 根据索引删除行
    removeLocalFeesRow: function removeLocalFeesRow(index) {
      // 检查是否为最后一行
      if (this.localFees.length <= 1) {
        this.$message.warning(this.$t('blExchangeAppointment.infoInputLeastFee'));
        return;
      }

      // 从当前显示的数组（即原始数组）中获取要删除的行
      var rowToDelete = this.localFees[index];
      if (rowToDelete.docEdoCreditFeeId) {
        // 是现有数据，标记为删除并移动到删除数组
        this.$set(rowToDelete, 'rowStatus', '8');
        this.deletedLocalFees.push(rowToDelete);
        this.localFees.splice(index, 1);
      } else {
        // 是新增数据，直接从数组中移除
        this.localFees.splice(index, 1);
      }
    },
    removeDemurrageRow: function removeDemurrageRow(index) {
      // 检查是否为最后一行
      if (this.demurrageFees.length <= 1) {
        this.$message.warning(this.$t('blExchangeAppointment.infoInputLeastFee'));
        return;
      }

      // 从当前显示的数组（即原始数组）中获取要删除的行
      var rowToDelete = this.demurrageFees[index];
      if (rowToDelete.docEdoCreditFeeId) {
        // 是现有数据，标记为删除并移动到删除数组
        this.$set(rowToDelete, 'rowStatus', '8');
        this.deletedDemurrageFees.push(rowToDelete);
        this.demurrageFees.splice(index, 1); // 从主数组移除
      } else {
        // 是新增数据，直接从数组中移除
        this.demurrageFees.splice(index, 1);
      }
    },
    // 验证金额
    validateAmount: function validateAmount(rule, value, callback) {
      if (!value) {
        callback(new Error(this.$t('blExchangeAppointment.mustInputAmount')));
      } else if (!/^\d+(\.\d{1,2})?$/.test(value)) {
        callback(new Error(this.$t('blExchangeAppointment.mustCheckFormat')));
      } else {
        callback();
      }
    },
    // 格式化日期为 yyyy-MM-dd HH:mm:ss
    formatDate: function formatDate(date) {
      var year = date.getFullYear();
      var month = (date.getMonth() + 1).toString().padStart(2, '0');
      var day = date.getDate().toString().padStart(2, '0');
      return "".concat(year, "-").concat(month, "-").concat(day, " 00:00:00");
    },
    handleSave: function handleSave() {
      if (!this.validateBasicInfo()) return;
      if (!this.validateRequiredFiles()) return;
      if (!this.validateFeeData()) return;

      // 准备表单数据
      this.prepareFormData();

      // 提交数据
      this.submitFormData();
    },
    /**
     * 验证基本信息
     */
    validateBasicInfo: function validateBasicInfo() {
      // 检查换单类型
      if (!this.form.documentType && this.form.documentType !== 0) {
        this.$message.warning(this.$t('blExchangeAppointment.infoCheckDocumentType'));
        return false;
      }

      // 检查收货人姓名
      if (!this.form.consigneeName) {
        this.$message.warning(this.$t('blExchangeAppointment.infoInputConsigneeName'));
        return false;
      }

      // 检查邮箱
      if (!this.form.mail) {
        this.$message.warning(this.$t('blExchangeAppointment.infoInputMail'));
        return false;
      }
      return true;
    },
    /**
     * 验证必须上传的文件
     */
    validateRequiredFiles: function validateRequiredFiles() {
      var _this2 = this;
      var documentTypeMap = {
        0: 'SURRENDERED',
        // 电放提单
        1: 'OBL',
        // 正本提单
        2: 'BG',
        // 银行保函
        3: 'FUC' // 货代单
      };
      var currentDocType = documentTypeMap[this.form.documentType] || '';
      var missingRequiredFiles = [];
      this.fileTypeConfig.forEach(function (fileType) {
        // 特殊处理taxAttachment
        if (fileType.formField === 'taxAttachment') {
          if (fileType.conditionalRequired === 'taxFlag == 1' && (_this2.form.taxFlag === '1' || _this2.form.taxFlag === 1)) {
            if (!_this2.form.taxAttachment) {
              missingRequiredFiles.push(fileType.fileTypeName);
            }
          }
          return;
        }

        // 检查文件是否必须
        var isRequired = false;

        // 检查是否符合当前单证类型的显示条件
        var shouldShow = fileType.showCondition.includes('ALL') || currentDocType && fileType.showCondition.includes(currentDocType);
        if (shouldShow && fileType.required) {
          // 检查条件性必填
          if (fileType.conditionalRequired) {
            if (fileType.conditionalRequired === 'hasDemurrage' && _this2.hasDemurrage) {
              isRequired = true;
            } else if (fileType.conditionalRequired === 'taxFlag == 1' && (_this2.form.taxFlag === '1' || _this2.form.taxFlag === 1)) {
              isRequired = true;
            }
          } else {
            isRequired = true;
          }
        }

        // 如果必填，则检查是否已上传
        if (isRequired) {
          var fileExists = _this2.form.approvalFiles.some(function (file) {
            return file.fileTypeCode === fileType.fileTypeCode;
          });
          if (!fileExists) {
            missingRequiredFiles.push(fileType.fileTypeName);
          }
        }
      });

      // 如果有必填文件未上传，则提示错误
      if (missingRequiredFiles.length > 0) {
        this.$message.warning(this.$t('blExchangeAppointment.mustUpload') + ": ".concat(missingRequiredFiles.join(', ')));
        return false;
      }
      return true;
    },
    /**
     * 验证费用行数据
     */
    validateFeeData: function validateFeeData() {
      // 验证滞期费
      if (this.hasDemurrage) {
        for (var i = 0; i < this.demurrageFees.length; i++) {
          if (!this.validateFeeRow(this.demurrageFees[i], i, 'demurrageFee')) {
            return false;
          }
        }
      } else {
        // 如果没有滞期费，确保demurrageFees为空数组
        this.demurrageFees = [];
      }

      // 验证本地费用
      for (var _i = 0; _i < this.localFees.length; _i++) {
        if (!this.validateFeeRow(this.localFees[_i], _i, 'localFee')) {
          return false;
        }
      }
      return true;
    },
    /**
     * 验证单个费用行
     */
    validateFeeRow: function validateFeeRow(row, index, feeType) {
      // 必填字段列表 - 基础必填字段，不包括银行和付款账号
      var requiredFields = ['paymentDate', 'paymentMethod', 'paymentCurrency', 'paymentAmount', 'invoiceNumber'];
      var requiredFieldNames = [this.$t('blExchangeAppointment.payDate'), this.$t('blExchangeAppointment.paymentMethod'), this.$t('blExchangeAppointment.currency'), this.$t('blExchangeAppointment.paymentAmount'), this.$t('blExchangeAppointment.invoiceNumber')];
      var feeTypeName = '';

      // 滞期费水单校验增加
      if (feeType === 'demurrageFee') {
        feeTypeName = this.$t('blExchangeAppointment.demurrageFees');
        requiredFields.push('attachmentId');
        requiredFieldNames.push(this.$t('blExchangeAppointment.demurrageReceipt'));
      }
      // 本地费用水单校验增加
      if (feeType === 'localFee') {
        feeTypeName = this.$t('blExchangeAppointment.localFees');
        requiredFields.push('attachmentId');
        requiredFieldNames.push(this.$t('blExchangeAppointment.bankSlip'));
      }

      // 检查基础必填字段是否为空
      for (var i = 0; i < requiredFields.length; i++) {
        var field = requiredFields[i];
        var fieldName = requiredFieldNames[i];
        if (row[field] === undefined || row[field] === null || row[field] === '') {
          this.$message.warning(this.$t('blExchangeAppointment.checkBaseInfo', {
            feeTypeName: feeTypeName,
            fieldName: fieldName,
            index: index + 1
          }));
          return false;
        }
      }

      // 特殊条件：当支付方式为网银转账(1)时，银行和付款账号必填
      if (row.paymentMethod === 1 || row.paymentMethod === '1') {
        // 检查银行是否填写
        if (row.paymentBank === undefined || row.paymentBank === null || row.paymentBank === '') {
          this.$message.warning(this.$t('blExchangeAppointment.checkBankInfo', {
            feeTypeName: feeTypeName,
            index: index + 1
          }));
          return false;
        }

        // 检查付款账号是否填写
        if (row.paymentAccount === undefined || row.paymentAccount === null || row.paymentAccount === '') {
          this.$message.warning(this.$t('blExchangeAppointment.checkPaymentAccountInfo', {
            feeTypeName: feeTypeName,
            index: index + 1
          }));
          return false;
        }

        // 验证付款账号格式（根据银行类型设置不同长度限制）
        if (row.paymentBank === 'BDO') {
          // BDO银行：1-10位数字
          if (!/^\d{1,10}$/.test(row.paymentAccount)) {
            this.$message.warning(this.$t('blExchangeAppointment.bdoRefNoMustBeDigits', {
              field: '10'
            }));
            return false;
          }
        } else {
          // 其他银行：1-15位数字
          if (!/^\d{1,15}$/.test(row.paymentAccount)) {
            this.$message.warning(this.$t('blExchangeAppointment.bdoRefNoMustBeDigits', {
              field: '15'
            }));
            return false;
          }
        }
      }

      // 验证金额格式
      if (!/^\d+(\.\d{1,2})?$/.test(row.paymentAmount)) {
        this.$message.warning(this.$t('blExchangeAppointment.checkPaymentFormat', {
          feeTypeName: feeTypeName,
          index: index + 1
        }));
        return false;
      }
      return true;
    },
    /**
     * 准备表单数据
     */
    prepareFormData: function prepareFormData() {
      // 确保approvalFiles数据格式正确
      if (!this.form.approvalFiles) {
        this.form.approvalFiles = [];
      }

      // 准备表单数据
      this.form.forespeakBlNo = this.forespeakBlNo;
      this.form.del = this.del;

      // 处理本地费用数据
      var mappedLocalFees = this.localFees.map(function (fee) {
        var isNew = !fee.docEdoCreditFeeId;
        return isNew ? (0, _objectSpread2.default)((0, _objectSpread2.default)({}, fee), {}, {
          feeType: fee.feeType || '0',
          rowStatus: '4' // 新增
        }) : (0, _objectSpread2.default)((0, _objectSpread2.default)({}, fee), {}, {
          rowStatus: '16' // 更新
        });
      });
      this.form.localFees = [].concat((0, _toConsumableArray2.default)(mappedLocalFees), (0, _toConsumableArray2.default)(this.deletedLocalFees));

      // 处理滞期费数据
      var mappedDemurrageFees = this.demurrageFees.map(function (fee) {
        var isNew = !fee.docEdoCreditFeeId;
        return isNew ? (0, _objectSpread2.default)((0, _objectSpread2.default)({}, fee), {}, {
          feeType: fee.feeType || '1',
          rowStatus: '4' // 新增
        }) : (0, _objectSpread2.default)((0, _objectSpread2.default)({}, fee), {}, {
          rowStatus: '16' // 更新
        });
      });
      this.form.demurrageFees = this.hasDemurrage ? [].concat((0, _toConsumableArray2.default)(mappedDemurrageFees), (0, _toConsumableArray2.default)(this.deletedDemurrageFees)) : []; // 如果没有滞期费，则为空数组

      // 确保edoCreditFiles已初始化
      if (!this.form.edoCreditFiles) {
        this.form.edoCreditFiles = {};
      }
    },
    /**
     * 提交表单数据
     */
    submitFormData: function submitFormData() {
      var _this3 = this;
      this.loading = (0, _utils.load)();
      (0, _blExchangeAppointment.saveForespeakPH)(this.form).then(function (res) {
        if (res.success) {
          _this3.$message({
            message: _this3.$t('blExchangeAppointment.reservationSuccessful'),
            type: 'success'
          });
          _this3.closed();
        } else {
          _this3.$message.error(_this3.$t('blExchangeAppointment.reservationFailure'));
        }
      }).catch(function (error) {
        _this3.$message.error(error.message || '操作失败');
        _this3.loading.close();
      }).finally(function () {
        _this3.loading.close();
      });
    },
    opened: function () {
      var _opened = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var _this4 = this;
        var initialData, initialLoading, param, initialRes, editLoading, res, existingData, localInvoiceUpdated, demInvoiceUpdated;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // 使用 async
              // 初始化所有数据，确保每次打开都是全新的状态
              this.initFormData();
              // 初始化状态值
              this.initStatusValues();
              initialData = null;
              initialLoading = (0, _utils.load)(); // Loading for initial data fetch
              _context.prev = 4;
              // 1. 始终先调用 getInitialData4PH
              param = {
                'blNo': this.vvLBlNo,
                'portCode': this.del
              };
              _context.next = 8;
              return (0, _blExchangeAppointment.getInitialData4PH)(param);
            case 8:
              initialRes = _context.sent;
              if (initialRes.success && initialRes.data) {
                initialData = initialRes.data;
                this.hasDemurrage = initialData.existsDEM === '1';
                console.log('获取到初始数据:', initialData);
              } else {
                this.$message.error(initialRes.message || '获取初始数据失败');
              }
              _context.next = 15;
              break;
            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](4);
              this.$message.error(_context.t0.message || '获取初始数据请求失败');
            case 15:
              _context.prev = 15;
              if (initialLoading) initialLoading.close();
              return _context.finish(15);
            case 18:
              if (!this.edoCreditId) {
                _context.next = 35;
                break;
              }
              // 2. 编辑模式: 获取已保存数据并合并初始数据
              editLoading = (0, _utils.load)(); // Loading for edit data fetch
              _context.prev = 20;
              _context.next = 23;
              return (0, _blExchangeAppointment.getForespeakAction)(this.edoCreditId, this.del);
            case 23:
              res = _context.sent;
              if (res.success && res.data) {
                existingData = res.data;
                console.log('获取到编辑数据:', existingData);

                // 2.1 使用编辑数据填充表单
                this.form = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.form), existingData);

                // 2.2 处理文件 (保持原有逻辑)
                if (existingData.approvalFiles && Array.isArray(existingData.approvalFiles)) {
                  this.form.approvalFiles = (0, _toConsumableArray2.default)(existingData.approvalFiles);
                } else {
                  this.convertEdoCreditFilesToApprovalFiles();
                }
                this.form.edoCreditFiles = existingData.edoCreditFiles || {};

                // 2.3 处理费用列表 (先用编辑数据填充)
                if (existingData.demurrageFees && Array.isArray(existingData.demurrageFees) && existingData.demurrageFees.length > 0) {
                  this.demurrageFees = (0, _toConsumableArray2.default)(existingData.demurrageFees);
                } else {
                  // 如果后端没返回，确保是空数组或默认结构
                  this.demurrageFees = this.hasDemurrage ? [{
                    docEdoCreditFeeId: '',
                    edoCreditId: '',
                    paymentDate: '',
                    paymentMethod: '',
                    paymentCurrency: '',
                    paymentAmount: '',
                    invoiceNumber: '',
                    paymentBank: '',
                    paymentAccount: '',
                    rowStatus: ''
                  }] : [];
                }
                if (existingData.localFees && Array.isArray(existingData.localFees) && existingData.localFees.length > 0) {
                  this.localFees = (0, _toConsumableArray2.default)(existingData.localFees);
                } else {
                  // 如果后端没返回，确保是空数组或默认结构
                  this.localFees = [{
                    docEdoCreditFeeId: '',
                    edoCreditId: '',
                    paymentDate: '',
                    paymentMethod: '',
                    paymentCurrency: '',
                    paymentAmount: '',
                    invoiceNumber: '',
                    paymentBank: '',
                    paymentAccount: '',
                    attachmentId: '',
                    attachmentName: '',
                    rowStatus: ''
                  }];
                }

                // 2.4 使用初始数据补充空字段
                if (initialData) {
                  // 补充 mail
                  if (!this.form.mail && initialData.noticeEmail) {
                    this.form.mail = initialData.noticeEmail;
                  }
                  // 补充 localFees invoiceNumber
                  if (initialData.localInvoiceNumber && this.localFees) {
                    localInvoiceUpdated = false;
                    this.localFees.forEach(function (fee) {
                      if (!fee._deleted && !fee.invoiceNumber) {
                        fee.invoiceNumber = initialData.localInvoiceNumber;
                        localInvoiceUpdated = true;
                      }
                    });
                    if (localInvoiceUpdated) console.log('已补充 localFees invoiceNumber:', initialData.localInvoiceNumber);
                    // 更新默认值，即使没有空行也更新，以防新增行使用
                    this.$set(this, 'defaultLocalInvoiceNumber', initialData.localInvoiceNumber);
                  }
                  // 补充 demurrageFees invoiceNumber
                  if (this.hasDemurrage && initialData.demInvoiceNumber && this.demurrageFees) {
                    demInvoiceUpdated = false;
                    this.demurrageFees.forEach(function (fee) {
                      if (!fee._deleted && !fee.invoiceNumber) {
                        fee.invoiceNumber = initialData.demInvoiceNumber;
                        demInvoiceUpdated = true;
                      }
                    });
                    if (demInvoiceUpdated) console.log('已补充 demurrageFees invoiceNumber:', initialData.demInvoiceNumber);
                    // 更新默认值
                    this.$set(this, 'defaultDemInvoiceNumber', initialData.demInvoiceNumber);
                  }
                }

                // 2.5 初始化文件显示列表
                this.$nextTick(function () {
                  _this4.initFileList();
                });
              } else {
                this.$message.error(res.message || '获取编辑数据失败');
              }
              _context.next = 30;
              break;
            case 27:
              _context.prev = 27;
              _context.t1 = _context["catch"](20);
              this.$message.error(_context.t1.message || '获取编辑数据请求失败');
            case 30:
              _context.prev = 30;
              if (editLoading) editLoading.close();
              return _context.finish(30);
            case 33:
              _context.next = 39;
              break;
            case 35:
              // 3. 新增模式: 使用初始数据填充
              this.form.paymentStatus = Number(this.paymentStatus || 0);
              this.form.forespeakStatus = Number(this.forespeakStatus || 0);
              if (initialData) {
                // 设置邮箱
                if (initialData.noticeEmail) {
                  this.form.mail = initialData.noticeEmail;
                }
                // 设置本地费用的发票号码 (给第一行)
                if (initialData.localInvoiceNumber && this.localFees && this.localFees.length > 0) {
                  // 确保localFees有默认行结构
                  if (!this.localFees[0]) this.localFees[0] = {
                    docEdoCreditFeeId: '',
                    edoCreditId: '',
                    paymentDate: '',
                    paymentMethod: '',
                    paymentCurrency: '',
                    paymentAmount: '',
                    invoiceNumber: '',
                    paymentBank: '',
                    paymentAccount: '',
                    attachmentId: '',
                    attachmentName: '',
                    rowStatus: ''
                  };
                  this.localFees[0].invoiceNumber = initialData.localInvoiceNumber;
                  this.$set(this, 'defaultLocalInvoiceNumber', initialData.localInvoiceNumber);
                }
                // 设置滞期费的发票号码 (给第一行)
                if (this.hasDemurrage && initialData.demInvoiceNumber && this.demurrageFees && this.demurrageFees.length > 0) {
                  // 确保demurrageFees有默认行结构
                  if (!this.demurrageFees[0]) this.demurrageFees[0] = {
                    docEdoCreditFeeId: '',
                    edoCreditId: '',
                    paymentDate: '',
                    paymentMethod: '',
                    paymentCurrency: '',
                    paymentAmount: '',
                    invoiceNumber: '',
                    paymentBank: '',
                    paymentAccount: '',
                    rowStatus: ''
                  };
                  this.demurrageFees[0].invoiceNumber = initialData.demInvoiceNumber;
                  this.$set(this, 'defaultDemInvoiceNumber', initialData.demInvoiceNumber);
                }
              }
              // 新增模式也需要初始化文件列表（可能为空）
              this.$nextTick(function () {
                _this4.initFileList();
              });
            case 39:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[4, 12, 15, 18], [20, 27, 30, 33]]);
      }));
      function opened() {
        return _opened.apply(this, arguments);
      }
      return opened;
    }(),
    closed: function closed() {
      var _this5 = this;
      // 重置表单的验证状态
      this.$nextTick(function () {
        _this5.$refs.form.resetFields();
      });
      // 清理数据
      this.initFormData();
      this.edoCreditId = '';
      // 关闭对话框
      this.$emit('update:visible', false);
    },
    // 初始化表单数据
    initFormData: function initFormData() {
      // 重置表单为默认值
      this.form = {
        blNo: '',
        mail: '',
        forespeakBlNo: [],
        ownerType: '',
        identifier: '',
        consigneeName: '',
        consigneeAddress: '',
        paymentStatus: 0,
        forespeakStatus: 0,
        bankSlip: '',
        paymentType: '',
        paymentCurrency: '',
        paymentAmount: '',
        invoiceNumber: '',
        paymentDate: '',
        taxFlag: '0',
        documentType: '',
        oblFileId: '',
        bankGuarantyFileId: '',
        deliveryOrder: '',
        billOfLadingCopy: '',
        idCardScan: '',
        insuranceCertificate: '',
        authorizationLetter: '',
        containerGuarantee: '',
        demurrageReceipt: '',
        oblWithBankStamp: '',
        demurrageReceiptName: '',
        taxAttachment: '',
        demurrageFees: [],
        localFees: [],
        approvalFiles: [],
        edoCreditFiles: {}
      };
      // 重置费用数据为默认值
      this.demurrageFees = [{
        docEdoCreditFeeId: '',
        edoCreditId: '',
        paymentDate: '',
        paymentMethod: '',
        paymentCurrency: '',
        paymentAmount: '',
        invoiceNumber: '',
        paymentBank: '',
        paymentAccount: '',
        attachmentId: '',
        // 添加附件ID字段
        attachmentName: '',
        // 添加附件名称字段
        rowStatus: ''
      }];
      this.localFees = [{
        docEdoCreditFeeId: '',
        edoCreditId: '',
        paymentDate: '',
        paymentMethod: '',
        paymentCurrency: '',
        paymentAmount: '',
        invoiceNumber: '',
        paymentBank: '',
        paymentAccount: '',
        attachmentId: '',
        // 添加附件ID字段
        attachmentName: '',
        // 添加附件名称字段
        rowStatus: ''
      }];
      this.deletedLocalFees = []; // 重置删除数组
      this.deletedDemurrageFees = []; // 重置删除数组
      // 清除文件列表
      this.fileList = [];
      // 清除缓存的默认值
      this.$set(this, 'defaultLocalInvoiceNumber', '');
      this.$set(this, 'defaultDemInvoiceNumber', '');
    },
    // 通用文件校验方法
    validateFile: function validateFile(file, fileList) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var _options$maxSize = options.maxSize,
        maxSize = _options$maxSize === void 0 ? 10 * 1024 * 1024 : _options$maxSize;
      if (!file) {
        return false;
      }

      // 检查文件大小
      if (file.size > maxSize) {
        this.$message.warning(this.$t('blExchangeAppointment.fileSize'));
        fileList = [];
        return false;
      }
      return true;
    },
    // 通用文件上传方法
    uploadFile: function uploadFile(item, destinationIdField) {
      var _this6 = this;
      if (!this.validateFile(item.file, this.fileListMSDS)) {
        return;
      }
      this.loading = (0, _utils.load)();
      var formData = new FormData();
      formData.append('file', item.file);
      formData.append('bucket', 'commerce');

      // 根据destinationIdField查找对应的文件类型配置
      var fileTypeInfo = this.fileTypeConfig.find(function (config) {
        return config.formField === destinationIdField;
      });
      if (!fileTypeInfo) {
        this.$message.error("\u672A\u627E\u5230\u5B57\u6BB5 ".concat(destinationIdField, " \u7684\u6587\u4EF6\u7C7B\u578B\u914D\u7F6E"));
        this.loading.close();
        return;
      }
      (0, _booking.setUploadFile)(formData).then(function (res) {
        if (res.code) {
          // taxAttachment直接保存到form对象
          if (destinationIdField === 'taxAttachment') {
            _this6.form.taxAttachment = res.fileId;
            _this6.form.taxAttachmentName = res.fileName;
            _this6.$message.success(_this6.$t('blExchangeAppointment.uploadSuccess', {
              fileTypeName: fileTypeInfo.fileTypeName
            }));
          } else {
            // 其他文件正常保存到approvalFiles
            // 先删除相同类型的文件（如果存在）
            var existingFileIndex = _this6.form.approvalFiles.findIndex(function (file) {
              return file.fileTypeCode === fileTypeInfo.fileTypeCode;
            });

            // 创建新的文件对象
            var newFile = {
              fileTypeCode: fileTypeInfo.fileTypeCode,
              fileTypeName: fileTypeInfo.fileTypeName,
              fileId: res.fileId,
              fileName: res.fileName,
              fileDescription: "\u8FD9\u662F\u4E00\u4EFD".concat(fileTypeInfo.fileTypeName, "\u6587\u4EF6")
            };
            if (existingFileIndex >= 0) {
              // 如果已存在相同类型的文件，则替换它
              _this6.form.approvalFiles.splice(existingFileIndex, 1, newFile);
            } else {
              // 否则添加新文件
              _this6.form.approvalFiles.push(newFile);
            }

            // 兼容旧代码，也更新旧字段
            _this6.form[destinationIdField] = res.fileId;
            if (_this6.form.edoCreditFiles) {
              _this6.form.edoCreditFiles[destinationIdField] = res.fileId;
              _this6.form.edoCreditFiles[destinationIdField + 'Name'] = res.fileName;
            }
            _this6.$message.success(_this6.$t('blExchangeAppointment.uploadSuccess', {
              fileTypeName: fileTypeInfo.fileTypeName
            }));
          }
        } else {
          _this6.$message.success(_this6.$t('blExchangeAppointment.uploadFail', {
            fileTypeName: fileTypeInfo.fileTypeName
          }));
        }
      }).catch(function (error) {
        _this6.$message.success(_this6.$t('blExchangeAppointment.uploadFail', {
          fileTypeName: fileTypeInfo.fileTypeName
        }));
      }).finally(function () {
        _this6.loading.close();
      });
    },
    beforeRemove: function beforeRemove(file) {},
    handleRemove: function handleRemove(file, fileField) {
      // 如果传入了具体的字段名，则使用它
      var destinationIdField = fileField;

      // 如果没有传入字段名，则尝试从file对象中识别
      if (!destinationIdField && file && file.uid) {
        // 处理taxAttachment
        if (this.form.taxAttachment === file.uid) {
          this.form.taxAttachment = '';
          this.form.taxAttachmentName = '';
          return;
        }

        // 在approvalFiles中查找对应的文件
        var fileIndex = this.form.approvalFiles.findIndex(function (f) {
          return f.fileId === file.uid;
        });
        if (fileIndex >= 0) {
          // 找到对应的文件类型配置
          var removedFile = this.form.approvalFiles[fileIndex];
          var fileTypeInfo = this.fileTypeConfig.find(function (config) {
            return config.fileTypeCode === removedFile.fileTypeCode;
          });
          if (fileTypeInfo) {
            destinationIdField = fileTypeInfo.formField;
          }

          // 从approvalFiles数组中移除该文件
          this.form.approvalFiles.splice(fileIndex, 1);
        }
      }

      // 如果找到对应的字段名，同时更新旧的数据结构
      if (destinationIdField) {
        this.form[destinationIdField] = '';
        if (this.form.edoCreditFiles) {
          this.form.edoCreditFiles[destinationIdField] = '';
          this.form.edoCreditFiles[destinationIdField + 'Name'] = '';
        }
      }
    },
    handleDownload: function handleDownload() {},
    // 新增方法：初始化文件显示列表
    initFileList: function initFileList() {
      var _this7 = this;
      // 首先初始化approvalFiles数组
      if (this.form.approvalFiles && this.form.approvalFiles.length > 0) {
        // 已有approvalFiles数据，直接使用
      } else if (this.form.edoCreditFiles) {
        // 从旧数据结构转换到新数据结构
        this.form.approvalFiles = [];
        this.fileTypeConfig.forEach(function (config) {
          // 跳过taxAttachment，因为它直接保存在form对象上
          if (config.formField === 'taxAttachment') {
            return;
          }
          var fieldName = config.formField;
          if (_this7.form.edoCreditFiles[fieldName] && _this7.form.edoCreditFiles[fieldName + 'Name']) {
            _this7.form.approvalFiles.push({
              fileTypeCode: config.fileTypeCode,
              fileTypeName: config.fileTypeName,
              fileId: _this7.form.edoCreditFiles[fieldName],
              fileName: _this7.form.edoCreditFiles[fieldName + 'Name'],
              fileDescription: "\u8FD9\u662F\u4E00\u4EFD".concat(config.fileTypeName, "\u6587\u4EF6")
            });
          }
        });
      }
      // 在 approvalFiles 准备好之后，更新文件编辑状态
      this.updateFileEditStatuses();

      // 创建字段名到ref名的映射
      var refMapping = {
        'bankSlip': 'bankSlip',
        'demurrageReceipt': 'demurrageReceipt',
        'taxAttachment': 'taxAttachment',
        'containerGuarantee': 'containerGuarantee',
        'authorizationLetter': 'authorizationLetter',
        'insuranceCertificate': 'insuranceCertificate',
        'idCardScan': 'idCardScan',
        'billOfLadingCopy': 'billOfLadingCopy',
        'deliveryOrder': 'deliveryOrder',
        'oblFileId': 'oblFileId',
        'bankGuarantyFileId': 'bankGuarantyFileId',
        'oblWithBankStamp': 'oblWithBankStamp'
      };

      // 根据当前显示控制条件设置需要实际初始化的字段
      var fieldsToInitialize = [];
      Object.keys(refMapping).forEach(function (field) {
        // 根据不同的字段类型和当前的显示状态决定是否需要初始化
        var shouldInitialize = false;
        if (field === 'bankSlip' || field === 'demurrageReceipt' || field === 'taxAttachment') {
          shouldInitialize = true; // 这些始终显示
        } else if (field === 'billOfLadingCopy') {
          shouldInitialize = _this7.checkSURRENDERED;
        } else if (field === 'deliveryOrder') {
          shouldInitialize = _this7.checkFUC;
        } else if (field === 'oblFileId') {
          shouldInitialize = _this7.checkOBL;
        } else if (field === 'bankGuarantyFileId' || field === 'oblWithBankStamp') {
          shouldInitialize = _this7.checkBG;
        } else if (['containerGuarantee', 'authorizationLetter', 'insuranceCertificate', 'idCardScan'].includes(field)) {
          shouldInitialize = _this7.checkSURRENDERED || _this7.checkOBL || _this7.checkFUC || _this7.checkBG;
        }
        if (shouldInitialize) {
          fieldsToInitialize.push(field);
        }
      });

      // 遍历需要初始化的字段
      fieldsToInitialize.forEach(function (field) {
        // 特殊处理taxAttachment
        if (field === 'taxAttachment') {
          // 处理taxAttachment文件
          if (_this7.form.taxAttachment && _this7.form.taxAttachmentName) {
            _this7.$nextTick(function () {
              var upload = _this7.$refs[refMapping[field]];
              if (upload) {
                var uploadInstance = upload;
                if (Array.isArray(upload)) {
                  uploadInstance = upload[0];
                }
                if (uploadInstance) {
                  // 创建文件对象
                  var fileObj = {
                    name: _this7.form.taxAttachmentName,
                    url: '',
                    // 可以根据需要设置下载URL
                    status: 'success',
                    uid: _this7.form.taxAttachment,
                    response: {
                      fileId: _this7.form.taxAttachment
                    }
                  };

                  // 更新uploadFiles
                  uploadInstance.uploadFiles = [fileObj];
                }
              }
            });
          }
          return;
        }

        // 特殊处理bankSlip
        if (field === 'bankSlip') {
          // 处理bankSlip文件
          if (_this7.localFees[0] && _this7.localFees[0].attachmentId) {
            _this7.$nextTick(function () {
              var upload = _this7.$refs[refMapping[field]];
              _this7.currentBankSlipId = _this7.localFees[0].attachmentId;
              _this7.currentBankSlipName = _this7.localFees[0].attachmentName;
              if (upload) {
                var uploadInstance = upload;
                if (Array.isArray(upload)) {
                  uploadInstance = upload[0];
                }
                if (uploadInstance) {
                  // 创建文件对象
                  var fileObj = {
                    name: _this7.localFees[0].attachmentName,
                    url: '',
                    // 可以根据需要设置下载URL
                    status: 'success',
                    uid: _this7.localFees[0].attachmentId,
                    response: {
                      fileId: _this7.localFees[0].attachmentId
                    }
                  };

                  // 更新uploadFiles
                  uploadInstance.uploadFiles = [fileObj];
                }
              }
            });
          }
          return;
        }

        // 从approvalFiles中查找对应类型的文件
        var fileTypeInfo = _this7.fileTypeConfig.find(function (config) {
          return config.formField === field;
        });
        if (!fileTypeInfo) return;
        var fileInfo = _this7.form.approvalFiles.find(function (file) {
          return file.fileTypeCode === fileTypeInfo.fileTypeCode;
        });
        if (fileInfo) {
          // 使用$nextTick确保DOM已更新
          _this7.$nextTick(function () {
            // 找到对应的上传组件
            var refName = refMapping[field];
            if (!_this7.$refs[refName]) {
              return;
            }
            var upload = _this7.$refs[refName];

            // 如果找到了上传组件，更新其文件列表
            if (upload) {
              var uploadInstance = upload;
              if (Array.isArray(upload)) {
                uploadInstance = upload[0];
              }
              if (uploadInstance) {
                // 创建文件对象
                var fileObj = {
                  name: fileInfo.fileName,
                  url: '',
                  // 可以根据需要设置下载URL
                  status: 'success',
                  uid: fileInfo.fileId,
                  response: {
                    fileId: fileInfo.fileId
                  }
                };

                // 更新uploadFiles
                uploadInstance.uploadFiles = [fileObj];
              }
            }
          });
        }
      });
    },
    // 添加新方法：将旧的edoCreditFiles格式转换为新的approvalFiles数组格式
    convertEdoCreditFilesToApprovalFiles: function convertEdoCreditFilesToApprovalFiles() {
      var _this8 = this;
      if (!this.form.edoCreditFiles) {
        this.form.approvalFiles = [];
        return;
      }
      this.form.approvalFiles = [];

      // 遍历文件类型配置，转换每个文件
      this.fileTypeConfig.forEach(function (config) {
        // 跳过taxAttachment，因为它直接保存在form对象上
        if (config.formField === 'taxAttachment') {
          // 单独处理taxAttachment
          if (_this8.form.edoCreditFiles.taxAttachment && _this8.form.edoCreditFiles.taxAttachmentName) {
            _this8.form.taxAttachment = _this8.form.edoCreditFiles.taxAttachment;
            _this8.form.taxAttachmentName = _this8.form.edoCreditFiles.taxAttachmentName;
          }
          return;
        }
        var fieldName = config.formField;
        if (_this8.form.edoCreditFiles[fieldName] && _this8.form.edoCreditFiles[fieldName + 'Name']) {
          _this8.form.approvalFiles.push({
            fileTypeCode: config.fileTypeCode,
            fileTypeName: config.fileTypeName,
            fileId: _this8.form.edoCreditFiles[fieldName],
            fileName: _this8.form.edoCreditFiles[fieldName + 'Name'],
            fileDescription: "\u8FD9\u662F\u4E00\u4EFD".concat(config.fileTypeName, "\u6587\u4EF6")
          });
        }
      });
    },
    // 添加新方法：为特定滞期费行上传文件
    uploadDemurrageFeeFile: function uploadDemurrageFeeFile(item, rowIndex) {
      var _this9 = this;
      if (!this.validateFile(item.file, [])) {
        return;
      }
      this.loading = (0, _utils.load)();
      var formData = new FormData();
      formData.append('file', item.file);
      formData.append('bucket', 'commerce');
      (0, _booking.setUploadFile)(formData).then(function (res) {
        if (res.code) {
          // 将文件信息保存到对应的demurrageFees行
          if (_this9.demurrageFees[rowIndex]) {
            _this9.$set(_this9.demurrageFees[rowIndex], 'attachmentId', res.fileId);
            _this9.$set(_this9.demurrageFees[rowIndex], 'attachmentName', res.fileName);

            // 验证该字段
            // this.$refs.form.validateField(`demurrageFees[${rowIndex}].attachmentId`);

            _this9.$message.success(_this9.$t('blExchangeAppointment.uploadSuccess', {
              fileTypeName: _this9.$t('blExchangeAppointment.demurrageReceipt')
            }));
          }
        } else {
          _this9.$message.success(_this9.$t('blExchangeAppointment.uploadFail', {
            fileTypeName: _this9.$t('blExchangeAppointment.demurrageReceipt')
          }));
        }
      }).catch(function (error) {
        _this9.$message.success(_this9.$t('blExchangeAppointment.uploadFail', {
          fileTypeName: _this9.$t('blExchangeAppointment.demurrageReceipt')
        }));
      }).finally(function () {
        _this9.loading.close();
      });
    },
    // 添加新方法：移除特定滞期费行的文件
    handleDemurrageFeeFileRemove: function handleDemurrageFeeFileRemove(file, rowIndex) {
      if (this.demurrageFees[rowIndex]) {
        this.$set(this.demurrageFees[rowIndex], 'attachmentId', '');
        this.$set(this.demurrageFees[rowIndex], 'attachmentName', '');
        this.$message.success('已移除滞期费水单');
      }
    },
    // 添加新方法：获取特定滞期费行的文件列表
    getDemurrageFeeFileList: function getDemurrageFeeFileList(row) {
      if (!row) return [];
      // 确保attachmentId和attachmentName都存在且不为空字符串
      return row.attachmentId && row.attachmentName && row.attachmentId !== '' && row.attachmentName !== '' ? [{
        name: row.attachmentName,
        uid: row.attachmentId
      }] : [];
    },
    uploadSharedBankSlip: function uploadSharedBankSlip(item) {
      var _this10 = this;
      if (!this.validateFile(item.file, [])) {
        return;
      }
      this.loading = (0, _utils.load)();
      var formData = new FormData();
      formData.append('file', item.file);
      formData.append('bucket', 'commerce');
      (0, _booking.setUploadFile)(formData).then(function (res) {
        if (res.code) {
          // Update shared state
          _this10.currentBankSlipId = res.fileId;
          _this10.currentBankSlipName = res.fileName;

          // Propagate to all localFees rows
          _this10.localFees.forEach(function (fee) {
            _this10.$set(fee, 'attachmentId', _this10.currentBankSlipId);
            _this10.$set(fee, 'attachmentName', _this10.currentBankSlipName);
          });

          // Also update form fields if needed for validation trigger/compatibility
          _this10.form.bankSlip = _this10.currentBankSlipId;
          _this10.form.bankSlipName = _this10.currentBankSlipName;
          // Manually trigger validation on the hidden field or the form item prop
          // this.$refs.form.validateField('bankSlipValidationTrigger');

          _this10.$message.success(_this10.$t('blExchangeAppointment.uploadSuccess', {
            fileTypeName: _this10.$t('blExchangeAppointment.bankSlip')
          }));
        } else {
          _this10.$message.success(_this10.$t('blExchangeAppointment.uploadFail', {
            fileTypeName: _this10.$t('blExchangeAppointment.bankSlip')
          }));
        }
      }).catch(function (error) {
        _this10.$message.success(_this10.$t('blExchangeAppointment.uploadFail', {
          fileTypeName: _this10.$t('blExchangeAppointment.bankSlip')
        }));
      }).finally(function () {
        _this10.loading.close();
      });
    },
    updateFileEditStatuses: function updateFileEditStatuses() {
      var _this11 = this;
      // 重置 fileEditStatus 中的状态为默认值 (false 意味着可编辑)
      Object.keys(this.fileEditStatus).forEach(function (key) {
        _this11.fileEditStatus[key] = false;
      });

      // 重置表单中 bankSlip 和 taxAttachment 的 fileStatus (使用 $set 确保响应性)
      this.$set(this.form, 'bankSlipFileStatus', false);
      this.$set(this.form, 'taxAttachmentFileStatus', false);
      if (this.form.approvalFiles && this.form.approvalFiles.length > 0) {
        this.form.approvalFiles.forEach(function (approvedFile) {
          // 仅当 approvedFile.fileStatus 存在时才处理
          if (typeof approvedFile.fileStatus !== 'undefined' && approvedFile.fileStatus !== null) {
            var statusValue = approvedFile.fileStatus === 1 || approvedFile.fileStatus === 0;
            switch (approvedFile.fileTypeCode) {
              case 'CONTAINER_GUARANTEE':
                _this11.fileEditStatus.containerGuaranteeFileStatus = statusValue;
                break;
              case 'AUTHORIZATION_LETTER':
                _this11.fileEditStatus.authorizationLetterFileStatus = statusValue;
                break;
              case 'INSURANCE_CERTIFICATE':
                _this11.fileEditStatus.insuranceCertificateFileStatus = statusValue;
                break;
              case 'ID_CARD_SCAN':
                _this11.fileEditStatus.idCardScanFileStatus = statusValue;
                break;
              case 'BILL_OF_LADING_COPY':
                _this11.fileEditStatus.billOfLadingCopyFileStatus = statusValue;
                break;
              case 'DELIVERY_ORDER':
                _this11.fileEditStatus.deliveryOrderFileStatus = statusValue;
                break;
              case 'OBL_FILE':
                // 对应 oblFileIdFileStatus
                _this11.fileEditStatus.oblFileIdFileStatus = statusValue;
                break;
              case 'OBL_WITH_BANK_STAMP':
                _this11.fileEditStatus.oblWithBankStampFileStatus = statusValue;
                break;
              case 'BANK_GUARANTY':
                // PRE_TAX_RECEIPT 对应 taxAttachment
                _this11.fileEditStatus.bankGuarantyFileIdFileStatus = statusValue;
                break;
            }
          }
        });
      }
    },
    // 验证付款账号（通用验证器，用于表单验证规则）
    validatePaymentAccount: function validatePaymentAccount(rule, value, callback) {
      if (!value) {
        callback(new Error(this.$t('home.placehold')));
        return;
      }

      // 从规则字段名中提取数组类型和索引
      var fieldPath = rule.field; // 例如: "localFees[0].paymentAccount" 或 "demurrageFees[1].paymentAccount"
      var match = fieldPath.match(/^(localFees|demurrageFees)\[(\d+)\]\.paymentAccount$/);
      if (!match) {
        // 如果无法解析字段路径，使用默认验证（15位）
        if (!/^\d{1,15}$/.test(value)) {
          callback(new Error(this.$t('blExchangeAppointment.bdoRefNoMustBeDigits', {
            field: '15'
          })));
        } else {
          callback();
        }
        return;
      }
      var _match = (0, _slicedToArray2.default)(match, 3),
        arrayType = _match[1],
        index = _match[2];
      var rowIndex = parseInt(index);

      // 获取对应行的数据
      var currentRow = null;
      if (arrayType === 'localFees' && this.localFees[rowIndex]) {
        currentRow = this.localFees[rowIndex];
      } else if (arrayType === 'demurrageFees' && this.demurrageFees[rowIndex]) {
        currentRow = this.demurrageFees[rowIndex];
      }
      if (!currentRow) {
        // 如果找不到对应行，使用默认验证（15位）
        if (!/^\d{1,15}$/.test(value)) {
          callback(new Error(this.$t('blExchangeAppointment.bdoRefNoMustBeDigits', {
            field: '15'
          })));
        } else {
          callback();
        }
        return;
      }

      // 根据paymentBank的值设置不同的验证规则
      var paymentBank = currentRow.paymentBank;
      if (paymentBank === 'BDO') {
        // BDO银行：1-10位数字
        if (!/^\d{1,10}$/.test(value)) {
          callback(new Error(this.$t('blExchangeAppointment.bdoRefNoMustBeDigits', {
            field: '10'
          })));
        } else {
          callback();
        }
      } else {
        // 其他银行：1-15位数字
        if (!/^\d{1,15}$/.test(value)) {
          callback(new Error(this.$t('blExchangeAppointment.bdoRefNoMustBeDigits', {
            field: '15'
          })));
        } else {
          callback();
        }
      }
    },
    // 处理金额输入，限制只能输入数字和最多两位小数
    handleAmountInput: function handleAmountInput(value, row, field) {
      // 只允许数字和小数点
      var newValue = value.replace(/[^\d.]/g, '');

      // 确保只有一个小数点
      var parts = newValue.split('.');
      if (parts.length > 2) {
        newValue = parts[0] + '.' + parts.slice(1).join('');
      }

      // 限制小数点后最多两位
      if (parts.length > 1 && parts[1].length > 2) {
        newValue = parts[0] + '.' + parts[1].substring(0, 2);
      }

      // 更新值
      if (newValue !== value) {
        row[field] = newValue;
      }
    },
    // 处理付款账号输入，只允许数字
    handlePaymentAccountInput: function handlePaymentAccountInput(value, row, index, feeType) {
      var _this12 = this;
      // 只允许数字，移除所有非数字字符
      var newValue = value.replace(/[^\d]/g, '');

      // 根据paymentBank设置不同的长度限制
      var maxLength = row.paymentBank === 'BDO' ? 10 : 15;
      if (newValue.length > maxLength) {
        newValue = newValue.substring(0, maxLength);
      }

      // 更新值
      if (newValue !== value) {
        row.paymentAccount = newValue;

        // 手动触发验证
        this.$nextTick(function () {
          var fieldName = "".concat(feeType, "[").concat(index, "].paymentAccount");
          _this12.$refs.form.validateField(fieldName);
        });
      }
    },
    // 处理银行选择改变，重新验证付款账号
    handleBankChange: function handleBankChange(row, index, feeType) {
      var _this13 = this;
      // 当银行选择改变时，清空付款账号并重新验证
      if (row.paymentAccount) {
        this.$nextTick(function () {
          // 重新验证付款账号字段
          var fieldName = "".concat(feeType, "[").concat(index, "].paymentAccount");
          _this13.$refs.form.validateField(fieldName);
        });
      }
    }
  }
};